import { render, staticRenderFns } from "./typeListing.vue?vue&type=template&id=248a5540&scoped=true&"
import script from "./typeListing.vue?vue&type=script&lang=js&"
export * from "./typeListing.vue?vue&type=script&lang=js&"
import style0 from "./typeListing.vue?vue&type=style&index=0&id=248a5540&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248a5540",
  null
  
)

export default component.exports